import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import FundUs from '../components/FundUs';

function FundUsPage() {
  return (
    <>
      <PageHero
        label="Infrastructure"
        title="Fund Us"
        subtitle="The science is done. We need the GPU."
      />
      <BackButton />
      <FundUs />
    </>
  );
}

export default FundUsPage;
